import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem;
  border: 1px solid ${Luiv3Constants.baseColor['gray-200']};
  & > :not(:last-child) {
    border-bottom: 1px solid #d9d9d9;
  }
`;

export default EntityContainer;
